import {
  React,
  Typography,
  AddToQueueIcon,
  // PerchaseScreen,
  ConnectedDevice,
  NOTConnectedDevice,
  InfoIcon,
  MoreVertIcon,
  DateRangeIcon,
  AdbIcon,
  useNavigate,
  CastIcon,
  useCallback,
  alpha,
  ModelTrainingIcon,
  ListItemButton,
  Menu,
  tooltipClasses,
  Tooltip,
  MenuItem,
  ListItemIcon,
  DeleteForeverIcon,
  AvTimerIcon,
  List,
  ListItem,
  memo,
  Button,
  toast,
  useState,
  Divider,
  Grid,
  Paper,
  Box,
  styled,
  swal,
  useUnlinkScreenMutation,
  useRefreshScreenMutation,
  GetCookie,
  DriveFileRenameOutlineIcon,
  HighlightOffIcon,
  AddCircleOutlineIcon,
  Dialog,
  useChnageScreenNameMutation,
  useCreateGroupMutation,
  useUpdateOrientationMutation,
} from "../../Libraries/Screens/index";
import AppbarTop from '../../components/PortalSidebar/Appbar/AppbarTop'
import Groupmodalimg from "../../Assets/svgs/Groupmodalimg.svg";
import PropTypes from "prop-types";
import CampaignIcon from "@mui/icons-material/Campaign";
import IconButton from "@mui/material/IconButton";
import AnnouncmentTxtToSpeech from "../Text-to-speech/announcment";
import Fab from "@mui/material/Fab";
import AddScreenIcon from "../../Assets/svgs/add_screen_image.svg";
import TTSIcon from "../../Assets/svgs/tts.svg";
import { useUpdateLayoutMutation } from "../../Redux/service/AllEmpData";
import { useEffect } from "react";
import ExpandableFab from "./ExpandableFab";
import {Select,RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
} from '@mui/material';
import ModalComp from '../../components/Modal';
import { Link } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import landscapeimage from '../../Assets/svgs/landscape.svg';
import notconnectedscreen from '../../Assets/svgs/notconnectedscreen.svg';
import Chip from '@mui/material/Chip';
import './screens.css';
import portraitleft from '../../Assets/svgs/Portrait-left.svg';
import portraitright from '../../Assets/svgs/Portrait-right.svg';
import orientationimg  from "../../Assets/svgs/orientationimg.svg";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const Screens = ({ getAllScreens, handleopendialog, AllScreens }) => {
  const [unlinkscreen] = useUnlinkScreenMutation();
  const [refreshscreen] = useRefreshScreenMutation();
  const [renameScreen] = useChnageScreenNameMutation();
  const [isAnnouncment, setisAnnouncment] = React.useState(false);
  const [AllCustomization, setAllCustomization] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [screenName, setScreenName] = useState("");
  const [updateLayout] = useUpdateLayoutMutation();
  const [group] = useCreateGroupMutation();
  const [updateorientation, { isLoading, isSuccess, isError }] = useUpdateOrientationMutation();
  const [assigngroupoption, setassigngroup] = useState(false);
  const [assignscreendata , setassignscreendata] =useState([]);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [error, setError] = useState("");
  const [maxerror, setmaxerror] = useState(false);
  const [isOrientationModalOpen, setIsOrientationModalOpen] = useState(false);
  const [selectedOrientation, setSelectedOrientation] = useState("");
  const [isConfirmed , setIsConfirmed] = useState(false);




  const [unlinkingscreen, setunlinkingscreen] = useState();
  const [data, setdata] = useState({
    openmodal: false,
    screenname: "",
  });

  useEffect(() => {
    getAllGroups();
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeScreenId, setActiveScreenId] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const receiverEmail =
    "muneeb.shahid@nayatel.com;sales@nayatel.com;cs@nayatel.com;boostboard@nayatel.com";
  const encodedSubject = encodeURIComponent(
    "Requirements for Additional BoostBoard Screens"
  );
  const encodedBody = encodeURIComponent(
    "Dear Nayatel Team, \n\nI need to add [x number] of BoostBoard screens. \n\nThank you"
  );
  const mailtoUrl = `mailto:${receiverEmail}?subject=${encodedSubject}&body=${encodedBody}`;

  const HandleTextToSpeech = () => {
    setisAnnouncment(true);
  };
  const AddMoreScreenClick = () => {
    window.location.href = mailtoUrl;
  };

  const handleClick = (event, screen) => {
    setAnchorEl(event.currentTarget);
    setSelectedScreen(screen);
    setunlinkingscreen(screen.ser_screen_id);
    setActiveScreenId(screen.ser_screen_id);
    setdata({
      ...data,
      screenname: screen.txt_screen_name,
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveScreenId(null);
  };

  const handleUnLink = (screen) => {
    swal({
      title: "Unlink Screen!",
      text: "Are you sure you want to unlink this screen?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        const payload = new FormData();
        payload.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("ser_screen_id", screen);
        const res = await unlinkscreen(payload).unwrap();
        if (
          res.connection === "true" &&
          res.status === "true" &&
          res.message === "Screen unlinked successfully"
        ) {
          toast.success(res.message);
          setAnchorEl(null);
          getAllScreens();
        } else {
          toast.error(res.message);
          setAnchorEl(null);
          getAllScreens();
        }
      } else {
        setAnchorEl(null);
      }
    });
  };

  const handleRefreshScreen = (screen) => {
    swal({
      title: "Refresh Screen!",
      text: "This will just refresh the screen nothing will lose!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        const payload = new FormData();
        payload.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("ser_screen_id", screen.ser_screen_id);

        const res = await refreshscreen(payload).unwrap();
        if (
          res.connection === "true" &&
          res.status === "true" &&
          res.message === "Screen refreshed automatically"
        ) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
          setAnchorEl(null);
          setActiveScreenId(null);
        }
       
      } else {
        setAnchorEl(null);
      }
    });
  };

  const handleScreenName = () => {
    setdata({
      ...data,
      openmodal: true,
    });
    setAnchorEl(null);
    setActiveScreenId(null);
  };

  const handleScreenNameChange = async () => {
    try {
      const payload = new FormData();
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_screen_id", unlinkingscreen);
      payload.append("txt_screen_name", data.screenname);
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      const res = await renameScreen(payload).unwrap();
      if (
        res.status === "true" &&
        res.connection === "true" &&
        res.message === "Screen renamed successfully"
      ) {
        toast.success(res.message);
        setdata({
          ...data,
          openmodal: false,
        });
        getAllScreens();
      } else {
        toast.error(res.message);
        setAnchorEl(null);
        setActiveScreenId(null);
      }
    } catch (error) {
      toast.error(error.status);
      setAnchorEl(null);
    }
  };

  const handleGetAllPosts = async (screen) => {
    navigate("/posts", {
      state: [
        {
          value: screen.ser_screen_id,
        },
      ],
    });
  };

  const editscreenname = (
    <React.Fragment>
      <Button variant="contained" 
        onClick={handleScreenNameChange} 
        className="capitalized fs-12 fw-bold"
        disabled={maxerror}
        >
        Save
      </Button>
    </React.Fragment>
  );

  const closemodal = () => {
    setError("");
    setmaxerror("");

    setdata({
      ...data,
      openmodal: false,
    });
  };
  const handleremovegroup = (screendata) => {
     swal({
      title: "Remove Group!",
      text: "Are you sure you want to remove the group?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        setAnchorEl(null);
        const customerId = localStorage.getItem("txt_customer_id");
        const formData = new FormData();
        formData.append("function", "UNASSIGN_GROUP");
        formData.append("ser_collection_id", screendata.ser_collection_id);
        formData.append("txt_customer_id", customerId);
        formData.append("ser_screen_id", screendata.ser_screen_id);
        formData.append("security_token", await GetCookie("es_token"));

        try {
          const response = await group(formData);
          if (response.data.status === "true") {
            toast.success(response.data.message);
            getAllScreens();
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.error("Error unassigning group:", error);
        }
        setAnchorEl(null);
      }else{
        console.error("Error Something went wrong");
      }
    });
  }
  const getAllGroups = async () => {
      const customerId = localStorage.getItem("txt_customer_id");
      const formData = new FormData();
      formData.append("function", "GET_ALL_GROUPS");
      formData.append("txt_customer_id", customerId);
      formData.append("security_token", await GetCookie("es_token"));
  
      try {
        const response = await group(formData);
        if (response.data.status === "true") {
          setGroupOptions(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
  const handleAssignGroup = (screendata) => {
    setScreenName(screendata.txt_screen_name);
    setIsModalOpen(true);
    setassignscreendata(screendata);
    setAnchorEl(null);
  }
  const renderModalContent = () => (
    <div className="d-flex flex-column justify-content-center align-items-center py-4">
      <div className="d-flex flex-column justify-content-center align-items-center gap-2 w-75">
        <img src={Groupmodalimg} alt="Group" />
        <div className="groupmodalwr d-flex flex-column justify-content-center align-items-center gap-1">
          <h3 className="fs-18 fw-semibold">Add Group to {screenName}</h3>
          <p className="text-center fs-12" style={{ color: "#00000099" }}>
            Select a group to add {screenName}. You can add only one screen at a time.
          </p>
        </div>

        <FormControl fullWidth>
          <Select
            displayEmpty
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            renderValue={(selected) => {
              if (!selected) return "Select a Group";
              const selectedOption = groupOptions.find(
                (option) => option.ser_collection_id === selected
              );
              return selectedOption ? selectedOption.txt_collection_name : "Select a Group";
            }}
            sx={{
              borderRadius: 2,
              backgroundColor: "#F9FAFB",
              borderColor: "#E0E0E0",
              padding: "0px !important",
              fontSize: "14px !important",
              height: "40px !important"
            }}
          >
            {groupOptions.map((option) => (
              <MenuItem key={option.ser_collection_id} value={option.ser_collection_id}
                  sx={{
                  fontSize: "14px !important",
                }}
              >
              
                <Radio
                  checked={selectedGroup === option.ser_collection_id}
                  value={option.ser_collection_id}
                  color="primary"
                  sx={{ marginRight: 1, width: "30px", transform: "scale(0.9)" }}
                />
                {option.txt_collection_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          className="capitalized fs-12 fw-bold"
          variant="contained"
          sx={{ width: "100%", mt: 1}}
          onClick={AssignGroup}
          disabled={!selectedGroup}
        >
          Assign Group
        </Button>
      </div>
    </div>
  );


    const closeModal = () => {
    setIsModalOpen(false);
    setSelectedGroup("");
  };
  React.useEffect(() => {
      if (isModalOpen) getAllGroups();
    }, [isModalOpen]);

  const AssignGroup = async () => {
        const customerId = localStorage.getItem("txt_customer_id");
        const formData = new FormData();
        formData.append("function", "ASSIGN_GROUP");
        formData.append("txt_customer_id", customerId);
        formData.append("ser_collection_id", selectedGroup);
        formData.append("screen_ids", JSON.stringify([assignscreendata.ser_screen_id]));
        formData.append("security_token",await GetCookie("es_token")); 
    
        try {
          const response = await group(formData);
          if (response.data.status === "true") {
            toast.success(response.data.message);
            closeModal();
            getAllScreens();

          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.error("Error assigning group:", error);
        }
      };
    const allowedPattern = /^[a-zA-Z0-9 .,()_\-]+$/;

    const handlerename = (e) => {
      let inputText = e.target.value;
      if (inputText && !allowedPattern.test(inputText)) {
        toast.error("Invalid characters entered.");
        inputText = inputText.replace(/[^a-zA-Z0-9 .,()_\-]/g, "");
      } 
      setdata((prev) => ({ ...prev, screenname: inputText }));
      const textinput = inputText.trim().length;
      if (textinput > 50) {
        setmaxerror(true);
        setError("Name must be 0–50 characters (including spaces).");
      } else {
          setError("");
          setmaxerror(false);
        }
    };

   const handleorientation = (screen) => {
      setSelectedScreen(screen);
      setSelectedOrientation(screen.txt_orientation_type_detail || "");
      setIsConfirmed(false); 
      setIsOrientationModalOpen(true);
    };
    const handleConfirmationChange = (e) => {
    setIsConfirmed(e.target.checked);
  };
  const handleOrientationChange = (e) => {
  setSelectedOrientation(e.target.value);
  setIsConfirmed(false); 
};

    const renderOrientationModal = () => (
       <div className="d-flex flex-column justify-content-center align-items-center py-4">
          <div className="d-flex flex-column justify-content-center align-items-center gap-3 w-75">
            <img src={orientationimg} width={151} height={151} alt="Orientation" />
            <h3 className="fs-24 fw-semibold">
              {selectedScreen?.txt_orientation_type
                ? selectedScreen.txt_orientation_type.charAt(0).toUpperCase() +
                  selectedScreen.txt_orientation_type.slice(1).toLowerCase() +
                  " Orientation"
                : "Orientation"}
            </h3>
            <p className="text-center fs-14" style={{ color: "#00000099" }}>
              Select an orientation for {selectedScreen?.txt_screen_name}.
            </p>

            <FormControl fullWidth className="d-flex gap-1">
              <Select
                labelId="orientation-select-label"
                id="orientation-select"
                value={selectedOrientation || ""}
                onChange={handleOrientationChange}
                sx={{
                  borderRadius: 2,
                  backgroundColor: "#F9FAFB",
                  borderColor: "#E0E0E0",
                  padding: "2px 0px !important",
                  fontSize: "14px !important",
                  height: "40px !important",
                }}
              >
                <MenuItem value="LANDSCAPE">
                  <FormControlLabel
                    value="LANDSCAPE"
                    control={
                      <Radio
                        checked={selectedOrientation === "LANDSCAPE"}
                        size="small"
                        sx={{ transform: "scale(0.8)" }}
                      />
                    }
                    label="Landscape"
                  />
                </MenuItem>

                <MenuItem value="PORTRAIT_LEFT">
                  <FormControlLabel
                    value="PORTRAIT_LEFT"
                    control={
                      <Radio
                        checked={selectedOrientation === "PORTRAIT_LEFT"}
                        size="small"
                        sx={{ transform: "scale(0.8)" }}
                      />
                    }
                    label="Portrait Left"
                  />
                </MenuItem>

                <MenuItem value="PORTRAIT_RIGHT">
                  <FormControlLabel
                    value="PORTRAIT_RIGHT"
                    control={
                      <Radio
                        checked={selectedOrientation === "PORTRAIT_RIGHT"}
                        size="small"
                        sx={{ transform: "scale(0.8)" }}
                      />
                    }
                    label="Portrait Right"
                  />
                </MenuItem>
              </Select>

              <div className="form-check mt-2">
                <input
                  type="checkbox"
                  id="confirmationCheckbox"
                  className="form-check-input pt-2"
                  checked={isConfirmed}
                  onChange={handleConfirmationChange}
                  disabled={!selectedOrientation} 
                  sx={{
                    cursor: "pointer",
                  }}
                />
                <label htmlFor="confirmationCheckbox" className="form-check-label fs-12">
                  Are you sure you want to change orientation into {selectedOrientation
                ? selectedOrientation.charAt(0).toUpperCase() +
                  selectedOrientation.slice(1).toLowerCase(): "Landscape"}
                </label>
              </div>
            </FormControl>

            <Button
              className="capitalized fs-12 fw-bold"
              variant="contained"
              sx={{ width: "100%", mt: 2 }}
              onClick={handleOrientationSave}
              disabled={!selectedOrientation || !isConfirmed}
            >
              Save Orientation
            </Button>
          </div>
        </div>
    );
      const handleOrientationSave = async () => {
        
        if (!selectedScreen || !selectedOrientation) {
          toast.error("Orientation not selected");
          return;
        }

        const orientationMap = {
          LANDSCAPE: {
            txt_orientation_type: "LANDSCAPE",
            txt_orientation_type_detail: "LANDSCAPE",
          },
          PORTRAIT_LEFT: {
            txt_orientation_type: "PORTRAIT",
            txt_orientation_type_detail: "PORTRAIT_LEFT",
          },
          PORTRAIT_RIGHT: {
            txt_orientation_type: "PORTRAIT",
            txt_orientation_type_detail: "PORTRAIT_RIGHT",
          },
        };

        const orientationPayload = orientationMap[selectedOrientation];

            if (!orientationPayload) {
              toast.error("Invalid orientation selected");
              return;
            }

            const {
              txt_orientation_type,
              txt_orientation_type_detail,
            } = orientationPayload;
            
            const safePattern = /^[A-Z_]+$/;

            if (
              !safePattern.test(txt_orientation_type) ||
              !safePattern.test(txt_orientation_type_detail)
            ) {
              toast.error("Invalid orientation format");
              return;
            }

            try {
              const customerId = localStorage.getItem("txt_customer_id");
              const securityToken = await GetCookie("es_token");

              const formData = new FormData();
              formData.append("ser_collection_id", selectedScreen.ser_collection_id);
              formData.append("txt_customer_id", customerId);
              formData.append("ser_code_id", selectedScreen.ser_code_id);
              formData.append("security_token", securityToken);
              formData.append("txt_orientation_type", txt_orientation_type);
              formData.append(
                "txt_orientation_type_detail",
                txt_orientation_type_detail
              );

              const response = await updateorientation(formData).unwrap();

              if (response.status === "true") {
                if(selectedScreen.ser_layout_id > 2){
                  const layoutForm = new FormData();
                  layoutForm.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                  layoutForm.append("security_token", await GetCookie("es_token"));
                  layoutForm.append("ser_screen_id", selectedScreen.ser_screen_id);
                  layoutForm.append("ser_layout_id", 1); 
                  await updateLayout(layoutForm).unwrap();
                }

                toast.success(response.message);
                getAllScreens();
                setIsOrientationModalOpen(false);
              } else {
                toast.error(response.message);
              }
            } catch (error) {
              console.error("Mutation error:", error);
              toast.error("Something went wrong while updating orientation.");
            }
          };
const truncateText = (text, maxLength = 5) => {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
};

  return (
    <React.Fragment>
       <Box className="mainboxscreen py-2">
            {/* <AppbarTop /> */}
            <Box
                sx={{ flexGrow: 1, mr: 3, mt: 1, mb: 3 }}
                style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000",
                    boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 8px",
                    borderRadius: "10px",
                }}
                className="py-4 px-4"
            >
                <span className="font-bold text-xl" style={{ fontSize: "20px" }}>
                    Screens
                </span>
                <div className="landscapemain">
                  {/* Landscape Screens */}
                  {AllScreens
                  .filter(screen => screen.txt_orientation_type === "LANDSCAPE" || screen.txt_orientation_type === null)
                  .map((screen, index) => {
                      const group = groupOptions.find(
                        (g) => Number(g.ser_collection_id) === Number(screen.ser_collection_id)
                      );

                      return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={`landscape-${index}`}>
                          <Box className="screencard">
                            <div className="orientationdiv">
                              <span style={{ color: "#1A75E8", fontWeight: "bold" }}>
                                {screen?.txt_screen_name || "-"}
                              </span>
                              {screen?.is_mapped === "true" ? (
                                  <div
                                    className="infodiv d-flex align-items-center justify-content-end"
                                    style={{
                                      height: "32px",             
                                      gap: "4px",         
                                      paddingRight: "4px",
                                    }}
                                  >
                                    <HtmlTooltip
                                      placement="bottom-end"
                                      title={
                                        <React.Fragment>
                                          <div className="flex align-items-center justify-content-between">
                                            <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                              <span className="mr-1">
                                                <DateRangeIcon sx={{ fontSize: "18px" }} />
                                              </span>
                                              Creation Date:
                                            </span>
                                            <div className="flex align-items-center justify-content-center ml-3">
                                              {screen?.dte_created_date || "-"}
                                            </div>
                                          </div>

                                          <div className="flex align-items-center justify-content-between">
                                            <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                              <span className="mr-1">
                                                <DateRangeIcon sx={{ fontSize: "18px" }} />
                                              </span>
                                              Model:
                                            </span>
                                            <div className="flex align-items-center justify-content-center">
                                              {screen?.txt_android_model || "-"}
                                            </div>
                                          </div>

                                          <div className="flex align-items-center justify-content-between">
                                            <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                              <span className="mr-1">
                                                <DateRangeIcon sx={{ fontSize: "18px" }} />
                                              </span>
                                              Brand:
                                            </span>
                                            <div className="flex align-items-center justify-content-center">
                                              {screen?.txt_device_brand || "-"}
                                            </div>
                                          </div>

                                          <div className="flex align-items-center justify-content-between">
                                            <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                              <span className="mr-1">
                                                <DateRangeIcon sx={{ fontSize: "18px" }} />
                                              </span>
                                              Device Name:
                                            </span>
                                            <div className="flex align-items-center justify-content-center">
                                              {screen?.txt_device_name || "-"}
                                            </div>
                                          </div>

                                          <div className="flex align-items-center justify-content-between">
                                            <span className="font-medium mt-1 mb-1">
                                              <span className="mr-1">
                                                <AdbIcon sx={{ fontSize: "18px" }} />
                                              </span>
                                              Android Version:
                                            </span>
                                            <div className="flex align-items-center justify-content-center">
                                              {screen?.txt_android_version || "-"}
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      }
                                    >
                                      <div
                                        style={{
                                          width: "28px",
                                          height: "28px",
                                          backgroundColor: "#E8F0FE",
                                          borderRadius: "50%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <InfoIcon sx={{ fontSize: "18px", color: "#1976D2" }} />
                                      </div>
                                    </HtmlTooltip>

                                    <MoreVertIcon
                                      sx={{
                                        cursor: "pointer",
                                        color: "#1976D2",
                                        fontSize: "22px",
                                      }}
                                      onClick={(e) => handleClick(e, screen)}
                                    />
                                    {/* <StyledMenu
                                      id="screenmenu"
                                      MenuListProps={{
                                        "aria-labelledby": "demo-customized-button",
                                      }}
                                      anchorEl={anchorEl}
                                      open={anchorEl && activeScreenId === screen.ser_screen_id}
                                      onClose={handleClose}
                                      PaperProps={{
                                        sx: {
                                          minWidth: '146px !important',
                                          // top: '195px !important',   
                                          // left: '448px !important',
                                          borderRadius: '10px',
                                          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
                                          padding: '4px 0',
                                          backgroundColor: '#ffffff',
                                        },
                                      }}
                                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    > */}
                                    <StyledMenu
                                        id="screenmenu"
                                        MenuListProps={{
                                          "aria-labelledby": "demo-customized-button",
                                        }}
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl) && activeScreenId === screen.ser_screen_id}
                                        onClose={handleClose}
                                        PaperProps={{
                                          sx: {
                                            minWidth: '146px',
                                            borderRadius: '10px',
                                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
                                            padding: '4px 0',
                                            backgroundColor: '#ffffff',
                                          },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                      >
                                      <MenuItem
                                        onClick={() => handleRefreshScreen(screen)}
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 1,
                                          fontSize: '14px',
                                          color: '#333',
                                          '&:hover': {
                                            backgroundColor: '#E3F2FD',
                                          },
                                        }}
                                      >
                                        <ModelTrainingIcon sx={{ fontSize: 18, color: '#1976D2' }} />
                                        Refresh
                                      </MenuItem>

                                      <MenuItem
                                        onClick={() => handleScreenName()}
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 1,
                                          fontSize: '14px',
                                          color: '#333',
                                          '&:hover': {
                                            backgroundColor: '#E3F2FD',
                                          },
                                        }}
                                      >
                                        <DriveFileRenameOutlineIcon sx={{ fontSize: 20, color: '#1976D2' }} />
                                        Rename
                                      </MenuItem>
                                    </StyledMenu>

                                  </div>
                                ) : (
                                  <div
                                    className="infodiv"
                                    style={{
                                      height: "32px", 
                                    }}
                                  />
                                )}
                            </div> 
                            <hr className="mx-0 my-0" style={{ borderColor: "#a2a2a2" }} />
                            <img
                              src={
                                  screen?.is_mapped === "true"
                                    ? landscapeimage
                                    : notconnectedscreen
                                }
                              alt={screen?.txt_screen_name || "-"}
                              style={{ width: "50%" }}
                              className="pt-1"
                            />

                            <div className="orientationdiv">
                              <span className="screenspan">Orientation</span>
                              <Link
                                className={`linkscreen ${!screen?.txt_orientation_type_detail ? "disabled-link" : ""}`}
                                style={{
                                  pointerEvents: !screen?.txt_orientation_type_detail ? "none" : "auto",
                                  color: !screen?.txt_orientation_type_detail ? "#aaa" : "inherit",
                                  cursor: !screen?.txt_orientation_type_detail ? "not-allowed" : "pointer",
                                  textDecoration: !screen?.txt_orientation_type_detail ? "none" : "underline",
                                }}
                                onClick={() => handleorientation(screen)}
                              >
                                {screen?.txt_orientation_type_detail
                                  ? screen.txt_orientation_type_detail.charAt(0).toUpperCase() +
                                    screen.txt_orientation_type_detail.slice(1).toLowerCase()
                                  : "Not Available"}
                              </Link>
                            </div>

                            <div className="orientationdiv">
                              <span className="screenspan">Group</span>
                              {group ? (
                                    <Chip
                                      label={`Mapped with ${truncateText(group.txt_collection_name)}`}
                                      onDelete={() => handleremovegroup(screen)}
                                      className="removegroup"
                                    />
                                  ) : (
                                    <>
                                        <Link
                                          className="linkscreen"
                                          onClick={() => handleAssignGroup(screen)} // open modal for this screen
                                          style={{ cursor: "pointer", color: "#1A75E8", textDecoration: "underline" }}
                                        >
                                          Assign Group
                                        </Link>

                                    </>
                                  )}

                              
                            </div>

                            <hr className="mx-0 my-3" style={{ borderColor: "#a2a2a2" }} />

                            <div className="orientationdiv">
                              {screen?.is_mapped === false || screen?.is_mapped === "false" ? (
                                <Button
                                  variant="outlined"
                                  sx={{ width: "90%" }}
                                  className="capitalized fs-12 fw-bold"
                                  onClick={() =>
                                    handleopendialog(screen?.txt_screen_name, screen?.ser_screen_id)
                                  }
                                >
                                  Link Screen
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() => handleUnLink(screen?.ser_screen_id)}
                                  sx={{ width: "100%" }}
                                  className="capitalized fs-12 fw-bold"
                                >
                                  Unlink Screen
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                sx={{ width: "90%" }}
                                onClick={() => handleGetAllPosts(screen)}
                                className="capitalized fs-12 fw-bold"
                                disabled={screen?.is_mapped === false || screen?.is_mapped === "false"}
                              >
                                Edit Media
                              </Button>
                            </div>
                          </Box>
                        </Grid>
                      );
                    })}

                </div>
                <hr className="mx-0 my-3" style={{ borderColor: "#a2a2a2" }} />

                  {/* Portrait Screens Section */}
                  <div className="landscapemain">
                  {AllScreens
                    .filter((screen) => screen?.txt_orientation_type === "PORTRAIT")
                    .map((screen, index) => {
                      const group = groupOptions.find(
                        (g) => Number(g.ser_collection_id) === Number(screen?.ser_collection_id)
                      );

                      return ( 
                        <Grid item xs={12} sm={6} md={4} lg={3} key={`portrait-${index}`}>
                          <Box className="screencard">
                            <div className="orientationdiv">
                              <span style={{ color: "#1A75E8", fontWeight: "bold" }}>
                                {screen?.txt_screen_name}
                              </span>

                              {screen?.is_mapped === "true" ? (
                                <div
                                  className="infodiv d-flex align-items-center justify-content-end"
                                  style={{
                                    height: "32px",
                                    gap: "4px",
                                    paddingRight: "4px",
                                  }}
                                >
                                  <HtmlTooltip
                                    placement="bottom-end"
                                    title={
                                      <React.Fragment>
                                        <div className="flex align-items-center justify-content-between">
                                          <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                            <span className="mr-1">
                                              <DateRangeIcon sx={{ fontSize: "18px" }} />
                                            </span>
                                            Creation Date:
                                          </span>
                                          <div>{screen?.dte_created_date}</div>
                                        </div>

                                        <div className="flex align-items-center justify-content-between">
                                          <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                            <span className="mr-1">
                                              <DateRangeIcon sx={{ fontSize: "18px" }} />
                                            </span>
                                            Model:
                                          </span>
                                          <div>{screen?.txt_android_model}</div>
                                        </div>

                                        <div className="flex align-items-center justify-content-between">
                                          <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                            <span className="mr-1">
                                              <DateRangeIcon sx={{ fontSize: "18px" }} />
                                            </span>
                                            Brand:
                                          </span>
                                          <div>{screen?.txt_device_brand}</div>
                                        </div>

                                        <div className="flex align-items-center justify-content-between">
                                          <span className="font-medium mt-1 mb-1 d-flex align-items-center">
                                            <span className="mr-1">
                                              <DateRangeIcon sx={{ fontSize: "18px" }} />
                                            </span>
                                            Device Name:
                                          </span>
                                          <div>{screen?.txt_device_name}</div>
                                        </div>

                                        <div className="flex align-items-center justify-content-between">
                                          <span className="font-medium mt-1 mb-1">
                                            <span className="mr-1">
                                              <AdbIcon sx={{ fontSize: "18px" }} />
                                            </span>
                                            Android Version:
                                          </span>
                                          <div>{screen?.txt_android_version}</div>
                                        </div>
                                      </React.Fragment>
                                    }
                                  >
                                    <div
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        backgroundColor: "#E8F0FE",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <InfoIcon sx={{ fontSize: "18px", color: "#1976D2" }} />
                                    </div>
                                  </HtmlTooltip>

                                  <MoreVertIcon
                                    sx={{
                                      cursor: "pointer",
                                      color: "#1976D2",
                                      fontSize: "22px",
                                    }}
                                    onClick={(e) => handleClick(e, screen)}
                                  />

                                  <StyledMenu
                                  id="screenmenu"
                                  MenuListProps={{
                                    "aria-labelledby": "demo-customized-button",
                                  }}
                                  anchorEl={anchorEl}
                                  open={activeScreenId === screen?.ser_screen_id}
                                  onClose={handleClose}
                                  PaperProps={{
                                    sx: {
                                      minWidth: "146px !important",
                                      borderRadius: "10px",
                                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
                                      padding: "4px 0",
                                      backgroundColor: "#ffffff",
                                    },
                                  }}
                                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                >
                                  <MenuItem
                                    onClick={() => handleRefreshScreen(screen)}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      fontSize: "14px",
                                      color: "#333",
                                      "&:hover": {
                                        backgroundColor: "#E3F2FD",
                                      },
                                    }}
                                  >
                                    <ModelTrainingIcon sx={{ fontSize: 18, color: "#1976D2" }} />
                                    Refresh
                                  </MenuItem>

                                  <MenuItem
                                    onClick={() => handleScreenName(screen)}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      fontSize: "14px",
                                      color: "#333",
                                      "&:hover": {
                                        backgroundColor: "#E3F2FD",
                                      },
                                    }}
                                  >
                                    <DriveFileRenameOutlineIcon sx={{ fontSize: 20, color: "#1976D2" }} />
                                    Rename
                                  </MenuItem>
                                </StyledMenu>
                                </div>
                              ) : (
                                <div className="infodiv" style={{ height: "32px" }} />
                              )}
                            </div>

                            <hr className="mx-0 my-2" style={{ borderColor: "#a2a2a2" }} />

                            <img
                              src={
                                screen.txt_orientation_type_detail === "PORTRAIT_LEFT"
                                  ? portraitleft
                                  : portraitright
                              }
                              alt={screen.name}
                              style={{ width: "30%" }}
                            />

                            <div className="orientationdiv mt-2">
                              <span className="screenspan">Orientation</span>
                              <Link className="linkscreen" onClick={() => handleorientation(screen)}>
                                {screen?.txt_orientation_type_detail
                                  ? screen?.txt_orientation_type_detail.charAt(0).toUpperCase() + screen?.txt_orientation_type_detail.slice(1).toLowerCase()
                                  : "Not Available"}
                              </Link>
                            </div>

                            <div className="orientationdiv">
                              <span className="screenspan">Group</span>
                              {group ? (
                                <Chip
                                  label={`Mapped with ${truncateText(group.txt_collection_name)}`}
                                  onDelete={() => handleremovegroup(screen)}
                                  className="removegroup"
                                />
                              ) : (
                                <Link
                                  className="linkscreen"
                                  onClick={() => {
                                    if (screen?.is_mapped === false || screen?.is_mapped === "false") return;
                                    handleAssignGroup(screen);
                                  }}
                                  style={{
                                    cursor:
                                      screen?.is_mapped === false || screen?.is_mapped === "false"
                                        ? "not-allowed"
                                        : "pointer",
                                    color:
                                      screen?.is_mapped === false || screen?.is_mapped === "false"
                                        ? "#999"
                                        : "#1A75E8",
                                    textDecoration: "underline",
                                    pointerEvents:
                                      screen?.is_mapped === false || screen?.is_mapped === "false"
                                        ? "none"
                                        : "auto",
                                  }}
                                >
                                  Assign Group
                                </Link>

                              )}
                            </div>

                            <hr className="mx-0 my-3" style={{ borderColor: "#a2a2a2" }} />

                            <div className="orientationdiv">
                               {screen?.is_mapped === "false" ? (
                                <Button
                                  variant="outlined"
                                  sx={{ width: "90%" }}
                                  className="capitalized fs-12 fw-bold"
                                  onClick={() =>
                                    handleopendialog(screen?.txt_screen_name, screen?.ser_screen_id)
                                  }
                                >
                                  Link Screen
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() => handleUnLink(screen?.ser_screen_id)}
                                  sx={{ width: "100%" }}
                                  className="capitalized fs-12 fw-bold"
                                >
                                  Unlink Screen
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                sx={{ width: "90%" }}
                                onClick={() => handleGetAllPosts(screen)}
                                className="capitalized fs-12 fw-bold"
                              >
                                Edit Media
                              </Button>
                            </div>
                          </Box>
                        </Grid>
                      );
                    })}
                </div>

            </Box>
        </Box>
         


      <Dialog
        visible={data?.openmodal}
        style={{ width: "500px" }}
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        header={"Rename Screen"}
        modal
        footer={editscreenname}
        onHide={closemodal}
      >
        {error && (
        <div style={{ color: "red", marginTop: "4px", marginBottom:"10px", fontSize: "14px" }}>
          {error}
        </div>
        )}
        <div className="field">
          <input
            id="name"
            type="text"
            value={data?.screenname}
            onChange={handlerename}
            placeholder="Screen name"
            className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
      </Dialog>

      <ModalComp
              open={isModalOpen}
              onCloseModal={closeModal}
              modalwidth="40%"
              modalheight="520px"
              closeicon={true}
            >
              {renderModalContent()}
            </ModalComp>
            <ModalComp
              open={isOrientationModalOpen}
              onCloseModal={() => setIsOrientationModalOpen(false)}
              modalwidth="40%"
              modalheight="520px"
              closeicon={true}
            >
              {renderOrientationModal()}
            </ModalComp>


      <AnnouncmentTxtToSpeech
        isAnnouncment={isAnnouncment}
        closeAnnouncmentModal={() => setisAnnouncment(false)}
      />

      <Grid
        container
        className="p-5"
        direction="column"
        columnSpacing={3}
        justifyContent="space-evenly"
        alignItems="flex-end"
        item
        xs={12}
        md={12}
        lg={12}
        xl={12}
      >
        <Grid item className="mb-2">
          <ExpandableFab
            text="Add more screens"
            iconName="0"
            clickFuntion={AddMoreScreenClick}
          />
        </Grid>

        <Grid className="mt-2">
          {AllScreens[0] && AllScreens[0] !== undefined ? (
            <ExpandableFab
              text="Text to speech"
              iconName="1"
              clickFuntion={HandleTextToSpeech}
            />
          ) : null}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

Screens.propTypes = {
  getAllScreens: PropTypes.func,
  handleopendialog: PropTypes.func,
  AllScreens: PropTypes.array,
};

export default memo(Screens);
